module.exports = __webpack_public_path__ + "img/zfbphone.a97d4819.png";